import type { TOC } from '@ember/component/template-only';
import { get } from '@ember/helper';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type { Platform } from 'frontend-utils/utils/constants/constant-values';
import {
  PLATFORM_ICONS,
  PLATFORM_TRANSLATION_KEYS,
} from 'lumen/utils/constants/general-constants';

interface ParityTablesCellsTdPlatformSignature {
  Args: {
    cellData: Platform;
  };
}

const ParityTablesCellsTdPlatform: TOC<ParityTablesCellsTdPlatformSignature> =
  <template>
    <div class="flex justify-center">
      <PrismIcon @name={{get PLATFORM_ICONS @cellData}} @size="small" />
      <PrismTooltip
        @side="top"
        @text={{t (get PLATFORM_TRANSLATION_KEYS @cellData)}}
      />
    </div>
  </template>;

export default ParityTablesCellsTdPlatform;
